import React, { useContext, useEffect, useState } from 'react'
import UserReview from './UserReview'
import QuickBuyContext from '@context/QuickBuyContext'

const AllReviews = ({
  data,
  sortPosition = "right",
  hideSeeAllButton = false,
  stickySortPosition = false,
}) => {
  const [reviews, setReviews] = useState([])

    //console.log(data)

    useEffect(() => {
        setReviews(data)
    }, [data]);

  return (
    <React.Fragment>
      <section className="w-full">
        
        <div className="w-full">
          {
            
            reviews && reviews?.length > 0 ? reviews?.map((item, index) => {
                return <UserReview key={`$user-review-${index}`} reviews={item} />;
            }) : <></>
            
          }
        </div>

      </section>
    </React.Fragment>
  );
};

export default AllReviews